import React from 'react';
import { Link } from 'react-router-dom';

// Phase 4 - US2: Admin Dashboard (T078)

export const AdminDashboard: React.FC = () => {
  return (
    <div className="admin-dashboard">
      <h1>Painel do Administrador</h1>

      <div className="dashboard-cards">
        <div className="card">
          <h2>Contratantes</h2>
          <p>Gerenciar empresas contratantes e seus contatos</p>
          <Link to="/admin/contractors" className="btn-primary">
            Acessar Contratantes
          </Link>
        </div>

        <div className="card">
          <h2>Pesquisas</h2>
          <p>Criar e gerenciar pesquisas eleitorais</p>
          <Link to="/admin/surveys" className="btn-primary">
            Acessar Pesquisas
          </Link>
        </div>

        <div className="card">
          <h2>Etiquetas</h2>
          <p>Gerenciar cadastro, edicao e inativacao de etiquetas</p>
          <Link to="/admin/tags" className="btn-primary">
            Acessar Etiquetas
          </Link>
        </div>

        <div className="card">
          <h2>Ciclos de Engajamento</h2>
          <p>Configurar períodos, prêmios e dados de sorteio</p>
          <Link to="/admin/engagement/cycles" className="btn-primary">
            Acessar Ciclos
          </Link>
        </div>

        <div className="card">
          <h2>Regulamento do Sorteio</h2>
          <p>Publicar e atualizar o regulamento da loteria federal</p>
          <Link to="/admin/engagement/regulation" className="btn-primary">
            Acessar Regulamento
          </Link>
        </div>

        <div className="card">
          <h2>Análises</h2>
          <p>Relatórios e métricas de pesquisas</p>
          <Link to="/admin/analytics" className="btn-primary">
            Ver Análises
          </Link>
        </div>

        <div className="card">
          <h2>Termos / Política</h2>
          <p>Gerenciar Termos de Uso e Política de Privacidade</p>
          <Link to="/admin/legal" className="btn-primary">
            Acessar Documentos
          </Link>
        </div>

        <div className="card">
          <h2>Usuários</h2>
          <p>Gerenciar usuários do sistema</p>
          <Link to="/admin/users" className="btn-primary">
            Acessar Usuários
          </Link>
        </div>

        <div className="card">
          <h2>Comunicação em Massa</h2>
          <p>Disparar email para segmentos de usuários, participantes de pesquisa ou lista JSON</p>
          <Link to="/admin/bulk-email" className="btn-primary">
            Acessar Comunicação em Massa
          </Link>
        </div>

        <div className="card">
          <h2>Perguntas Frequentes</h2>
          <p>Cadastrar e gerenciar perguntas e respostas do FAQ público</p>
          <Link to="/admin/faq" className="btn-primary">
            Acessar FAQ
          </Link>
        </div>

        <div className="card">
          <h2>Provedores e Modelos de IA</h2>
          <p>Configurar provedores, modelos e homologação de retenção para análises por IA</p>
          <Link to="/admin/ai-models" className="btn-primary">
            Acessar Modelos de IA
          </Link>
        </div>
      </div>
    </div>
  );
};
